import React, {FC, ReactNode, useCallback, useRef} from 'react';

import {ViewerPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {getIsSandboxGeneralInboxTicketingEnabled} from '../../../../store/data/inboxes/inboxesSelectors';
import {MentionEducationTip} from './mentionEducationTip';
import {SandboxEducationTipProps} from './sandboxEducationTip';
import {SandboxEducationTipCoordinator} from './sandboxEducationTipCoordinator';

/*
 * Props.
 */

interface MentionEducationTipCoordinatorProps {
  className?: string;
  conversationId: number | undefined;
  isEditingExistingComment: boolean;
  children: ReactNode;
  panelId: ViewerPanelId;
  onSetCommentComposerText: (newText: string) => void;
}

/*
 * Component.
 */

export const MentionEducationTipCoordinator: FC<MentionEducationTipCoordinatorProps> = (props) => {
  const {conversationId, children, isEditingExistingComment, panelId, onSetCommentComposerText} = props;

  const onSetCommentComposerTextRef = useRef(onSetCommentComposerText);
  onSetCommentComposerTextRef.current = onSetCommentComposerText;

  const renderEducationTip = useCallback(
    (educationTipProps: SandboxEducationTipProps) => {
      const {anchor, onNextClick, onEndClick} = educationTipProps;
      return (
        <MentionEducationTip
          conversationId={conversationId}
          anchor={anchor}
          isVisible
          onNextClick={onNextClick}
          onEndClick={onEndClick}
          panelId={panelId}
          onSetCommentComposerText={onSetCommentComposerTextRef.current}
        />
      );
    },
    [panelId, conversationId],
  );

  const isGeneralSandboxInboxTicketing = useAppSelector(getIsSandboxGeneralInboxTicketingEnabled);

  if (isEditingExistingComment) {
    return <>{children}</>;
  }

  return (
    <SandboxEducationTipCoordinator
      className={props.className}
      conversationId={props.conversationId}
      scenario={
        isGeneralSandboxInboxTicketing
          ? SandboxScenariosEnum.SCENARIO5_ACT1
          : SandboxScenariosEnum.SCENARIO3_ACT1
      }
      step="mention-marisa"
      isEligible
      renderEducationTip={renderEducationTip}
    >
      {props.children}
    </SandboxEducationTipCoordinator>
  );
};
